import React, { useState } from 'react'
import BottomBar from '../components/BottomBar'
import CategoryBoxes from '../components/CategoryBoxes'
import Offer from '../components/Offer'
import Slider from '../components/Slider'
import Search from '../components/Search'
import Header from '../components/Header'

const Home = ({ ...props }) => {
	const [showSearchPage, setShowSearchPage] = useState(false)
	console.log('done done ', showSearchPage)
	return (
		<div className=' pb-24'>
			<Header setShowSearchPage={setShowSearchPage}></Header>
			<div
				className={showSearchPage ? 'd-none' : ''}
				style={{
					display: showSearchPage ? 'none' : 'block',
				}}
			>
				<Offer></Offer>
				<CategoryBoxes></CategoryBoxes>
				<BottomBar></BottomBar>
			</div>
		</div>
	)
}

export default Home
